import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Subscription gate: any paid endpoint returns 402 -> bounce to the paywall.
api.interceptors.response.use(
  (r) => r,
  (err) => {
    const status = err?.response?.status;
    const path = typeof window !== "undefined" ? window.location.pathname : "";
    if (status === 402 && !path.startsWith("/subscribe")) {
      window.location.assign("/subscribe");
    }
    return Promise.reject(err);
  }
);

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
